import { createSlice } from "@reduxjs/toolkit";
import { fetchDoctorAppointmentsReducer } from "../../reducer/appointments/fetchDoctorAppointmentsReducer";

import i18n from "../../i18n";
const initialState = {
  data: [],
  total: 0,
  page: 1,
  limit: 10,
  totalPages: 1,
  isLoading: false,
  error: null,
};

const doctorAppointmentsSlice = createSlice({
  name: "doctorAppointments",
  initialState,
  reducers: {
    updateAppointmentStatus: (state, action) => {
      const { appointmentId, status, payment_status } = action.payload;
      // Find and update the appointment in the data array
      const appointmentIndex = state.data.findIndex(
        (appointment) => appointment.id === appointmentId,
      );
      if (appointmentIndex !== -1) {
        const existing = state.data[appointmentIndex];
        state.data[appointmentIndex] = {
          ...existing,
          status: status,
          // Optionally update payment_status too (e.g. cash marked collected →
          // 'paid'), keeping it in sync both at the top level and inside `raw`
          // (the invoice reads through both) so the UI reflects it immediately.
          ...(payment_status
            ? {
                payment_status,
                raw: existing.raw
                  ? { ...existing.raw, payment_status }
                  : existing.raw,
              }
            : {}),
        };
      }
    },
    setOnsiteScheduleUpdated: (state, action) => {
      const { appointmentId } = action.payload;
      // Find and update the appointment to mark onsite schedule as updated
      const appointmentIndex = state.data.findIndex(
        (appointment) => appointment.id === appointmentId,
      );
      if (appointmentIndex !== -1) {
        state.data[appointmentIndex] = {
          ...state.data[appointmentIndex],
          onsiteScheduleUpdated: true,
          // The doctor has answered, so the response SLA has stopped. Clearing the timer
          // fields here makes the table's SLA column update immediately instead of counting
          // down against a deadline that no longer applies until the next list refetch.
          // The server clears the same fields on accept, so a later refetch agrees.
          sla_started_at: null,
          sla_due_at: null,
          sla_reminder_due_at: null,
          sla_is_urgent: false,
        };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDoctorAppointmentsReducer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchDoctorAppointmentsReducer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.appointments || action.payload || [];
        state.total =
          action.payload?.pagination?.total || action.payload?.total || 0;
        state.page =
          action.payload?.pagination?.page || action.payload?.page || 1;
        state.limit =
          action.payload?.pagination?.limit || action.payload?.limit || 10;
        state.totalPages =
          action.payload?.pagination?.total_pages ||
          (state.total > 0 && state.limit > 0
            ? Math.ceil(state.total / state.limit)
            : 1);
      })
      .addCase(fetchDoctorAppointmentsReducer.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || i18n.t("toast.failedToLoadDoctorAppointments");
      });
  },
});

export const { updateAppointmentStatus, setOnsiteScheduleUpdated } =
  doctorAppointmentsSlice.actions;
export default doctorAppointmentsSlice.reducer;
